import { createSlice } from '@reduxjs/toolkit';
import { authApi } from '../api/authApi';

const initialAuthState = {
  jwt: '',
  expiredTime: 0,
  twoFaCheck: false,
  passwordResetRequired: false,
  forbiddenAction: false,
  secretSet: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    clearAuthentication: () => initialAuthState,
    updateJwt: (state, { payload }) => {
      state.jwt = payload.jwt;
    },
    updateExpiryTime: (state, { payload }) => {
      state.expiredTime = payload;
    },
    updateTwoFaCheck: (state, { payload }) => {
      state.twoFaCheck = payload;
    },
    updatePasswordRequiredCheck: (state, { payload }) => {
      state.passwordResetRequired = payload;
    },
    updateForbiddenAction: (state, { payload }) => {
      state.forbiddenAction = payload;
    },
    updateSecretSet: (state, { payload }) => {
      state.secretSet = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.authenticateUser.matchFulfilled,
      (state, { payload }) => {
        console.log('payload', payload);
        state.passwordResetRequired = payload.result.password_reset_required;
        state.jwt = payload.result.jwt;
        state.secretSet = payload.result.user.secretSet;
      }
    );
  },
});
export const {
  authenticate,
  clearAuthentication,
  updateJwt,
  updateExpiryTime,
  updateTwoFaCheck,
  updatePasswordRequiredCheck,
  updateForbiddenAction,
  logout,
  updateSecretSet,
} = authSlice.actions;
export default authSlice.reducer;
